"use client";

import { usePathname } from "next/navigation";
import { Header } from "../header";

/**
 * Conditional Header Component
 *
 * Renders the Header for all routes except /chat and public secure-link pages.
 * On /chat, returns null for full-screen chat. On /s/* (public secure links),
 * returns null so unauthenticated visitors never see the internal Hub nav.
 */
export function ConditionalHeader() {
  const pathname = usePathname();

  // Hide header on chat route (full-screen chat) and public secure-link pages.
  if (pathname === "/chat" || pathname.startsWith("/s/")) {
    return null;
  }

  return <Header />;
}
